import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = { class: "ta-c" };
const _hoisted_3 = { class: "ta-c" };
const _hoisted_4 = { class: "ta-c" };
const _hoisted_5 = { class: "ta-c" };
const _hoisted_6 = { class: "ta-c" };
const _hoisted_7 = { class: "ta-c" };
const _hoisted_8 = { class: "ta-c" };
const _hoisted_9 = { class: "ta-c" };
const _hoisted_10 = { class: "ta-c" };
import { workerAllocateTableHeaderData } from '@/constants/workerAllocate';
import { storeToRefs } from 'pinia';
import { pStore } from '@/pinia';
import { attendCode } from '@/constants';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WorkerList',
    setup(__props) {
        // 라이더 조회 배차 > 라이더 리스트
        const pWorkerAllocate = pStore.piniaWorkerAllocate;
        const { selectedWorker, filteredItemList, selectedWorkerOrderList, } = storeToRefs(pWorkerAllocate);
        const cssClassHighlight = (code) => selectedWorker.value?.workerCode === code;
        /**
         * 라이더 리스트 클릭 핸들러
         */
        const handleClickRow = (worker) => {
            if (selectedWorker.value?.workerCode === worker.workerCode) {
                selectedWorker.value = undefined;
                selectedWorkerOrderList.value = [];
            }
            else {
                selectedWorker.value = worker;
                pWorkerAllocate.getOrderByWorkerCode(selectedWorker.value.workerCode);
            }
        };
        return (_ctx, _cache) => {
            const _component_v_data_table = _resolveComponent("v-data-table");
            const _directive_tr_highlight = _resolveDirective("tr-highlight");
            return (_openBlock(), _createBlock(_component_v_data_table, {
                hover: "",
                class: "worker-list brg-table th-nowrap",
                density: "compact",
                "hide-default-footer": "",
                "fixed-header": "",
                "item-value": "code",
                headers: _unref(workerAllocateTableHeaderData).header,
                items: _unref(filteredItemList),
                "items-per-page": 0,
                "custom-key-sort": _unref(workerAllocateTableHeaderData).sort
            }, {
                item: _withCtx(({ item }) => [
                    _withDirectives((_openBlock(), _createElementBlock("tr", {
                        onClick: ($event) => (handleClickRow(item))
                    }, [
                        _createCommentVNode(" 허브명 "),
                        _createElementVNode("td", _hoisted_2, _toDisplayString(item.hubName), 1 /* TEXT */),
                        _createCommentVNode(" 라이더 코드 "),
                        _createElementVNode("td", _hoisted_3, _toDisplayString(item.workerCode), 1 /* TEXT */),
                        _createCommentVNode(" 라이더 사번 "),
                        _createElementVNode("td", _hoisted_4, _toDisplayString(item.workerHubNumber), 1 /* TEXT */),
                        _createCommentVNode(" 라이더명 "),
                        _createElementVNode("td", _hoisted_5, _toDisplayString(item.workerName), 1 /* TEXT */),
                        _createCommentVNode(" 상태 "),
                        _createElementVNode("td", _hoisted_6, [
                            _createElementVNode("span", {
                                class: _normalizeClass(_unref(attendCode)?.[item.workerAttend]?.textColorClass)
                            }, _toDisplayString(item.workerAttendCode), 3 /* TEXT, CLASS */)
                        ]),
                        _createCommentVNode(" 단말기 "),
                        _createCommentVNode(" <td class=\"ta-c\">\n          {{ formatPhoneNumber(item.workerPhone) }}\n        </td> "),
                        _createCommentVNode(" 연락처 "),
                        _createElementVNode("td", _hoisted_7, _toDisplayString(item.workerPhoneWithHyphen), 1 /* TEXT */),
                        _createCommentVNode(" 위치 "),
                        _createCommentVNode(" <td class=\"ta-c\">\n        </td> "),
                        _createCommentVNode(" 고객과거리 "),
                        _createElementVNode("td", _hoisted_8, _toDisplayString(item.distanceCustomer), 1 /* TEXT */),
                        _createCommentVNode(" 가맹점과거리 "),
                        _createElementVNode("td", _hoisted_9, _toDisplayString(item.getDistanceFromPickupWithKm), 1 /* TEXT */),
                        _createCommentVNode(" 차단여부 "),
                        _createElementVNode("td", _hoisted_10, _toDisplayString(item.isDeniedStoreToString), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_1)), [
                        [_directive_tr_highlight, cssClassHighlight(item.workerCode)]
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["headers", "items", "custom-key-sort"]));
        };
    }
});
